import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";

// Global axios interceptor — attaches the signed-in user's PriceValuator
// session token (and, during admin impersonation, the admin basic-auth
// header) to EVERY backend request. Removes the need for every call site
// to remember to pass auth headers.
axios.interceptors.request.use((config) => {
  try {
    const token = sessionStorage.getItem("pv_session_token");
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers["X-PV-Session"]) {
        config.headers["X-PV-Session"] = token;
      }
    }
    const adminAuth = sessionStorage.getItem("pv_admin_auth");
    if (adminAuth) {
      config.headers = config.headers || {};
      if (!config.headers["X-PV-Admin"]) {
        config.headers["X-PV-Admin"] = adminAuth;
      }
    }
  } catch {
    /* storage access can fail in sandboxed iframes — ignore */
  }
  return config;
});

// Broadcast an expired PriceValuator/Blexbot session so the app can prompt re-sign-in.
axios.interceptors.response.use(undefined, (error) => {
  try {
    const url = String(error?.config?.url || "");
    const isAuthOrAdmin = /\/api\/(login|register|admin\/)/.test(url);
    if (error?.response?.status === 401 && !isAuthOrAdmin && sessionStorage.getItem("pv_session_token")) {
      window.dispatchEvent(new Event("pv:session-expired"));
    }
  } catch {
    /* ignore */
  }
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
